(() => {
  const descriptionsIdMap = {};

  window.swinger = {
    ...window.swinger,
    a11y: {
      notify: (text) => {
        const appendContainer = document.getElementById('swinger-append-notify-container');

        if (!appendContainer) {
          return;
        }

        const notification = document.createElement('div');
        notification.textContent = text;

        appendContainer.appendChild(notification);
      },
      alert: (text) => {
        const appendContainer = document.getElementById('swinger-append-alert-container');

        if (!appendContainer) {
          return;
        }

        appendContainer.textContent = '';
        window.setTimeout(() => {
          appendContainer.textContent = text;
        });
      },
      createDescription: (text) => {
        if (descriptionsIdMap[text]) {
          return descriptionsIdMap[text];
        }

        const appendContainer = document.getElementById('swinger-append-container');

        if (!appendContainer) {
          return false;
        }

        const id = `swinger-description-${Object.keys(descriptionsIdMap).length + 1}`;
        const description = document.createElement('div');
        description.setAttribute('id', id);
        description.className = 'swinger-visuallyhidden';
        description.textContent = text;
        appendContainer.appendChild(description);

        descriptionsIdMap[text] = id;
        return id;
      },
    },
  };
})();
